import React, { useContext, useState, useCallback, useMemo } from "react";
import { withTools } from "../../../../helper/withTools";
import FuncionesContext from "../../../../context/FuncionesContext";
import ModalesContext from "../../../../context/ModalContext";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

const useStyle = makeStyles({
  inputBComponent: {
    "& .MuiInputBase-input": {
      //   height: "1.4375em",
      //  padding: "13px 14px",
    },
    "& .css-nnbavb": {
      display: "none",
    },
  },
});

const InputBuscador = (props) => {
  const { data, cab } = props;
  const {
    seleccion_multiple,
    columna_ida_valor,
    columna_ida_mostrar,
    filtro_ida_valor,
    pantalla_ida,
  } = cab;

  const { superSubmit } = useContext(FuncionesContext);

  const [termino, setTermino] = useState("");
  const [oid, setId] = useState("");
  const classes = useStyle();
  const [select_data, setSelectData] = useState({});

  const handleInput = (e) => {
    const { value } = e.target;
    setTermino(value);

    setId("");
  };

  const { escupirModal } = useContext(FuncionesContext);
  const { cerrarModal } = useContext(ModalesContext);

  const filtro = {
    [filtro_ida_valor]: termino, // filtro id_a a pasar al listado "MONODRO_LST_FILTRO_NOMBRE"
  };

  const handleSubmit = (data_selected) => {
    const data_send = data_selected.map((d) => {
      return d[columna_ida_valor];
    });

    superSubmit({
      valor: data_send,
      id_a: cab.id_a,
      update_id: data[cab.update_id_alias] ?? cab.update_id,
      handleCancelar: () => {},
      cab,
      data,
    });

    cerrarModal(pantalla_ida);
  };

  const opMultiple = {
    listado_seleccion: "s",
    showSelectAllCheckbox: false,
    showTextRowsSelected: false,
    onSelectionChange: (rowData) => {
      const noid = rowData.map((o) => o[columna_ida_valor]); // columna a setear como value "MONODRO_LST_ID"
      setTermino(rowData.map((t) => t[columna_ida_mostrar]).toString()); // columnda a mostrar "MONODRO_LST_NOMBRE"
      //funcion de guardar
      setSelectData(() => {
        return rowData;
      });
      setId(noid);
    },
    listado_filtro_termino: termino,
    filtrosDesdeInput: filtro,
    activarListado: !!termino,
    iniciar_activo: "n",
    submit_button: true,
    submit_button_handleSubmit: handleSubmit,
  };

  const opSimple = {
    onRowClick: (e, rowData, data) => {
      const noid = rowData[columna_ida_valor]; // columna a setear como value
      setTermino(rowData[columna_ida_mostrar]); // columnda a mostrar
      setId(noid);
      // funcion de guardar
      setSelectData(rowData);
    },
    onRowDoubleClick: (e, rowData) => {
      const noid = rowData[columna_ida_valor]; // columna a setear como value
      setTermino(rowData[columna_ida_mostrar]); // columnda a mostrar
      setId(noid);
      //funcion de guardar
      setSelectData(rowData);
      handleSubmit();
      cerrarModal(pantalla_ida);
    },
    rowStyle: true,
    listado_filtro_termino: termino,
    filtrosDesdeInput: filtro,
    activarListado: !!termino,
    iniciar_activo: "n", // como en realidad llama a la pantalla, el atributo inicial del listado es quien prevalece
    submit_button: true,
    submit_button_handleSubmit: handleSubmit,
  };

  const showModal = () =>
    escupirModal(
      pantalla_ida, // Listado para abrir "PANTALLA_LIST_MONODRO"
      {},
      seleccion_multiple === "s" ? opMultiple : opSimple
    );

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      showModal();
    }
  };

  return (
    <div id={cab.id_a} style={{ display: "flex" }}>
      {cab.nombre ? (
        <div className="vista_label vista_label_fuente">{cab.nombre}:</div>
      ) : (
        <></>
      )}
      <div className="filtroBuscador">
        <TextField
          onChange={handleInput}
          onKeyDown={handleKeyDown}
          value={termino}
          style={{ width: "84%", padding: "0 0" }}
          type="text"
          // variant="outlined"
          label={props.label}
          className={classes.inputBComponent}
        />
        <button
          onClick={() => showModal()}
          style={{
            padding: "0.23rem",
            backgroundColor: "#006F7A",
            color: "white",
            width: "15%",
            height: "100%",
          }}
          className="InputBusquedaLupa"
        >
          <i class="fa fa-search" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  );
};

export default withTools(InputBuscador);
